import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/constants/src/assets/template-7-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')